/**
 * @file counters-context.ts
 * @description Общий контракт групп панели «Счётчики и cookie» (phase19.16,
 * партия Р3г, v0.19.62; SB133, SB134): часть COUNTERS, вид баннера из темы,
 * цвета темы, политика платформы (запрет «Уведомления», редакции текстов),
 * запись части и раздела темы, живой показ на канве. Группы читают его из
 * контекста — без протаскивания пропсов через каждую (образец —
 * `cart-look-context`). Без права настроек панели нет вовсе (заглушка
 * «Только просмотр» в `WholeSitePanel`), поэтому режима просмотра здесь нет.
 */

import type { SiteConsentBanner, SiteCounters, SiteTheme } from "@chaiberi/shared";
import { createContext, useContext } from "react";

import type { CountersUpdateOptions } from "../../../hooks/site-view/useCountersDraft";
import type { SiteConsentPlatform } from "../../../lib/site-view/types";

export interface CountersApi {
  counters: SiteCounters;
  banner: SiteConsentBanner;
  theme: SiteTheme;
  /** Политика платформы; нет — встроенные тексты shared. */
  platform: SiteConsentPlatform | undefined;
  /** Разрешён ли платформой режим «Уведомление» (SB133). */
  noticeAllowed: boolean;
  /** Правка части COUNTERS (номера и вступление — уже проверенные). */
  update: (patch: Partial<SiteCounters>, options?: CountersUpdateOptions) => void;
  /** Правка вида баннера — раздел `theme.consentBanner` (часть THEME). */
  updateBanner: (patch: Partial<SiteConsentBanner>) => void;
  /** Показать на канве во время перетаскивания ползунка (не запись). */
  previewBanner: (patch: Partial<SiteConsentBanner>) => void;
}

export const CountersContext = createContext<CountersApi | null>(null);

export function useCounters(): CountersApi {
  const api = useContext(CountersContext);
  if (!api) throw new Error("useCounters(): группа «Счётчиков и cookie» рисуется только внутри CountersFields");
  return api;
}
